import React from 'react';
import AnswerKeyHeader from './AnswerKeyHeader';
import Prompt from './Prompt';
import Lure from './Lure';

const AnswerKeyQuestionsArray = ({ lesson, data, dir }) => {
  return data.content.core.map((question, index) => {
    return (
      <div
        key={question.id + '_' + index}
        className="page"
        style={{
          width: '8.5in',
          minHeight: '11in',
          padding: '0.5in',
          boxSizing: 'border-box',
          margin: '0 auto',
          border: '1px #D3D3D3 solid',
          borderRadius: '4px',
          background: 'white',
          pageBreakAfter: 'always',
          color: '#333'
        }}
      >
        <AnswerKeyHeader lesson={lesson} page={data} questionNum={index + 1} />
        {Prompt(question.prompt, 'Question ' + (index + 1), dir)}
        {question.lures.map((lure, idx) =>
          Lure(lure.lure_text, lure.is_correct, dir, idx)
        )}
      </div>
    );
  });
};

export default AnswerKeyQuestionsArray;
